import { RACHA_MAP } from "@/composables/common/rachaMap";

/**
 * Utilidades compartidas para manejar rachas (w/d/l) en todo el dashboard.
 * Provee funciones de transformación y extracción de badges para rachas.
 */
export function useRacha() {
    /**
     * Convierte una racha string en un array de badges con label, variant y char.
     *
     * @param {string} racha — string de racha estilo 'wwdlw'
     * @param {number} [maxChars=5] — número máximo de caracteres a mostrar
     * @returns {Array<{ char: string, label: string, variant: string }>}
     */
    function toBadges(racha, maxChars = 5) {
        if (typeof racha !== "string") return [];
        const chars = racha.slice(-maxChars).split("");
        return chars.map(c => {
            const key = c.toLowerCase();
            return {
                char: key,
                label: RACHA_MAP[key]?.label || c.toUpperCase(),
                variant: RACHA_MAP[key]?.color || "default",
            };
        });
    }

    /**
     * Extrae los últimos N caracteres de una racha.
     *
     * @param {string} racha
     * @param {number} [count=5]
     * @returns {string[]}
     */
    function lastChars(racha, count = 5) {
        if (typeof racha !== "string") return [];
        return racha.slice(-count).split("");
    }

    /**
     * Determina el variant del Badge según el carácter de racha.
     *
     * @param {string} char — 'w', 'l', 'd', etc.
     * @returns {string}
     */
    function badgeVariant(char) {
        return RACHA_MAP[char.toLowerCase()]?.color || "default";
    }

    /**
     * Label para el Badge según el carácter de racha.
     *
     * @param {string} char
     * @returns {string}
     */
    function badgeLabel(char) {
        return RACHA_MAP[char.toLowerCase()]?.label || char.toUpperCase();
    }

    return {
        toBadges,
        lastChars,
        badgeVariant,
        badgeLabel,
    };
}
